import React from "react";
import URI from "urijs";
import SwaggerUI from "swagger-ui-react";
import "./tryitout.css";
import "swagger-ui-react/swagger-ui.css";
import getUrl from "../../functions/getUrl";
import ScrollToTopOnMount from "../ScrollToTopOnMount";
import DocHeaderMenu from "../Docs/DocHeaderMenu";
import { RouteComponentProps } from "react-router";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import { selectAuth } from "../../store/auth/selectors";
import getLocationInfo, { Product } from "../../functions/getLocationInfo";

const cleanupInterval = 100;

interface ISwaggerData {
  [k: string]: any;
}

interface IResponse {
  [k: string]: any;
}

interface ITryItOutProps extends RouteComponentProps<{ product: string; apiType: string }> {
  token: string;
}

const TryItOut = (props: ITryItOutProps) => {
  const { token } = props;
  const {
    match: {
      params: { apiType, product },
    },
  } = props;

  function addHeader(request: ISwaggerData) {
    request.headers = {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    };
    return request;
  }

  const uri = URI(getUrl(`/TryItOut/${product}/`))
    .addSearch({
      apiType: apiType,
    })
    .toString();

  // extreme hackery so that the oauth token doesn't look super ugly
  // - steve made me do it
  const cleanup = (count: number) => () => {
    const nodes = document.querySelectorAll("textarea.curl");
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i] as HTMLTextAreaElement;
      if (node.value) {
        node.value = node.value.replace(
          /"Authorization.*"/i,
          // tslint:disable-next-line:quotemark
          '"{AUTH_HEADER}"',
        );
      }
    }

    const node = document.querySelector(".swagger-ui .info .main h2.title");
    if (node && node.innerHTML.includes("Skyward tryitout/SMS 2.0 Version 1")) {
      node.innerHTML = `<h2 class="title">LMS API v1<small><pre class="version"> LMS </pre></small></h2>`;
    }
    if (!nodes.length && count < 20) {
      setTimeout(cleanup(++count), cleanupInterval);
    }
  };

  const handleResponse = (res: IResponse) => {
    setTimeout(cleanup(1), cleanupInterval);
    return res;
  };

  return (
    <>
      <ScrollToTopOnMount />
      <DocHeaderMenu />
      <SwaggerUI
        url={uri}
        docExpansion="list"
        requestInterceptor={request => {
          return addHeader(request);
        }}
        responseInterceptor={res => handleResponse(res)}
      />
    </>
  );
};

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(TryItOut);
